//
//
//
//

import dayjs from "dayjs";
import Hours from "./Hours.vue";
import dayMap from '../lib/day-map';
import { dayjsFromTime } from '../lib/dayjs-helpers';

export default {
  data: () => ({
    location: false,

    hours: {
      isOpen: false,
      open: false,
      close: false,
      isBeforeOpening: false,
      isAfterClosing: false
    }
  }),

  components: {
    Hours
  },

  mounted() {
    $.getJSON(`/wp-json/wp/v2/location/${window.Location.id}`)
      .done(this.done)
      .fail(this.fail);
  },

  methods: {
    currentDayTimes() {
      let now = dayjs();
      let key = dayMap[now.day()];

      this.hours.open = dayjsFromTime(this.getLocationHours(key, "open"));
      this.hours.close = dayjsFromTime(this.getLocationHours(key, "close"));

      if (!this.hours.close.isValid()) {
        this.hours.isOpen = false;

        return;
      }

      this.hours.isOpen = true;

      if (now.isBefore(this.hours.open)) {
        this.hours.isOpen = false;
        this.hours.isBeforeOpening = true;
      }

      if (now.isAfter(this.hours.close)) {
        this.hours.isOpen = false;
        this.hours.isAfterClosing = true;
      }
    },

    getLocationHours(day, which) {
      return this.location.meta[`hours_${day}_${which}`];
    },

    done(response) {
      this.location = response;

      this.currentDayTimes();
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/components/LocationHours.vue